export default __webpack_public_path__ + "static/media/noFolderW.39c21160.svg";